import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type SnapshotKpiTrend = 'up' | 'down' | 'flat';

export interface SnapshotKpiCardItem {
  label: string;
  value: string;
  trend?: SnapshotKpiTrend;
  delta?: string;
  note?: string;
  barPercent?: number;
  barColor?: string;
  footnote?: string;
}

@Component({
  selector: 'lib-snapshot-kpi-card',
  standalone: true,
  imports: [CommonModule],
  host: { class: 'block h-full' },
  templateUrl: './snapshot-kpi-card.component.html',
})
export class SnapshotKpiCardComponent {
  @Input() label = '';
  @Input() value = '';
  @Input() trend: SnapshotKpiTrend = 'flat';
  @Input() delta = '';
  @Input() note = '';
  @Input() barPercent = 0;
  @Input() barColor = '';
  @Input() footnote = '';

  private readonly trendColors: Record<SnapshotKpiTrend, string> = {
    up: '#6b7a66',
    down: '#EF4444',
    flat: '#d0b993',
  };

  get resolvedBarColor(): string {
    return this.barColor || this.trendColors[this.trend] || this.trendColors.flat;
  }

  get barWidth(): number {
    return Math.max(0, Math.min(100, this.barPercent));
  }
}
